import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Button from "../../../components/button";
import Input from "../../../components/input";

const AddLogo = ({ isAddMoreOpen, closeAddMoreModal, uploadAndSaveImg }) => {
  const [img, setImg] = useState();
  const [logoType, setLogoType] = useState("APP_ICON");
  const [error, setError] = useState("")

  useEffect(() => {
    if (img) {
      setError("")
    }
  }, [img])

  const handleSave = () => {
    if (!img) {
      setError("Image required")
      return;
    }
    uploadAndSaveImg(img, logoType, "add");
    closeAddMoreModal();
    setImg()
  };

  return (
    <Modal
      show={isAddMoreOpen}
      onHide={closeAddMoreModal}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Add a Logo</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Input
          label="Logo Type"
          type="select"
          options={[
            { label: "App Icon", value: "APP_ICON" },
            { label: "Logo", value: "LOGO" },
            { label: "Splash Screen", value: "SPLASH_SCREEN" },
          ]}
          onChange={(e) => setLogoType(e.target.value)}
          className="mb-4"
        />
        <Input
          label="Upload a Logo"
          type="file"
          accept="image/png, image/jpeg"
          value={img}
          onChange={(e) => setImg(e.target.files[0])}
        />
        {error && <div className="text-danger">{error}</div>}
      </Modal.Body>
      <Modal.Footer>
        <Button text="Close" callBack={closeAddMoreModal} />
        <Button text="Save Changes" callBack={handleSave} />
      </Modal.Footer>
    </Modal>
  );
};

export default AddLogo;
